import React from 'react';
import { useEffect } from 'react';

const Installments = () => {
    useEffect(() => {
        document.title = 'NASCAR — Кредит';
    }, []);

    return <div className="page">
        <section>
            <h2>Оплата частями</h2>
            <p><b>Кредит</b> — это удобный и доступный способ приобрести товары, оплачивая их стоимость частями.
                <br />Мы предлагаем возможность оформления кредита на срок от 3 до 48 месяцев, что позволяет распределить затраты на длительный период. Это существенно снижает финансовую нагрузку и помогает комфортно планировать бюджет.
                <br />Чтобы оформить кредит, выберите нужный товар, заполните заявку и укажите подходящий срок кредитования.
                <br />Кредит дает вам возможность сразу получить желаемый товар, не откладывая покупку на будущее. Вы сможете наслаждаться новой покупкой уже сейчас, оплачивая ее постепенно.
                <br />Мы предоставляем прозрачные условия кредитования, без скрытых платежей и комиссий. Наша цель — сделать процесс покупки комфортным и доступным для каждого клиента.
                <br />Исполните свои мечты уже сегодня! Воспользуйтесь возможностью оформления кредита и приобретайте то, что вам нужно, прямо сейчас!
            </p>
            <h3>Условия кредитования:</h3>
            <ul>
                <li><b>ВОЗРАСТ:</b> от 18 до 75 лет (на момент окончания кредита/рассрочки)</li>
                <li><b>СРОК:</b> от 3 до 60 месяцев</li>
                <li><b>ПРОЦЕНТЫ:</b> годовые от 0% до 19,99% (зависит от кредитной нагрузки клиента)</li>
                <li><b>СУММА на товар:</b> не менее 100 бел.руб и не более 20000 бел.руб</li>
                <li><b>Кредит предоставляется:</b> гражданам РБ, лицам, имеющим вид на жительство</li>
            </ul>
            <p>В случае большой долговой нагрузки, плохой кредитной истории или имеющихся исполнительных документов, магазин также может предложить оформление через Лизингодателя.</p>
        </section>
    </div>;
};

export default Installments;
